export default __webpack_public_path__ + "static/media/stamp_1.dcf9c3a1.png";